export default "__VITE_ASSET__Bjdj1Jpd__"